import userPreferencesManager from './user-preferences-manager';

export default {
  userPreferencesManager,
};
